import { addTouchEvent } from "./events";
import { showSuccessSnackbar } from "./snackbar";
import { getEventParams, logEvent } from "./analytics";
import store from "./store";
import { getLogger } from "./logging";
import { incrementLives } from "./lives";

const difficultyFeedbackDialogEl = document.getElementById(
  "difficulty-feedback-dialog"
);
const difficultyFeedbackDialogTooEasyBtnEl = document.getElementById(
  "difficulty-feedback-dialog-too-easy"
);
const difficultyFeedbackDialogJustRightBtnEl = document.getElementById(
  "difficulty-feedback-dialog-just-right"
);
const difficultyFeedbackDialogTooHardBtnEl = document.getElementById(
  "difficulty-feedback-dialog-too-hard"
);
const difficultyFeedbackDialogSkipBtnEl = document.getElementById(
  "difficulty-feedback-dialog-skip"
);
const difficultyFeedbackDialogSubmitBtnEl = document.getElementById(
  "difficulty-feedback-dialog-submit"
);

const log = getLogger("Difficulty Feedback");

class DifficultyRating {
  constructor() {
    this.rating = null;
    this.resolve = null;
  }

  submit = () => {
    logEvent("submit_difficulty_feedback", {
      rating: this.rating,
      episodeIdx: store.episodeIdx,
      ...getEventParams(),
    });
    this.close();
    incrementLives(3);
    showSuccessSnackbar("You earned 3 lives for your feedback!");
    log.debug(
      `Difficulty rating ${this.rating} submitted for episode ${store.episodeIdx}`
    );
  };

  close = () => {
    difficultyFeedbackDialogEl.style.display = null;
    this.#resolve();
  };

  show = () => {
    const dialogPromise = new Promise((resolve) => {
      this.resolve = resolve;
    });
    const prevEpsideIdx = store.episodeIdx - 1;
    if (store.difficultyFeedbacks.has(prevEpsideIdx)) {
      console.error(
        `Difficulty feedback already shown for episode ${store.episodeIdx}`
      );
      return dialogPromise;
    }
    store.difficultyFeedbacks.add(prevEpsideIdx);
    difficultyFeedbackDialogEl.style.display = "block";
    return dialogPromise;
  };

  #resolve = () => {
    if (this.resolve) {
      this.resolve();
      this.resolve = null;
    } else console.error("No resolve function to call");
  };
}

export const difficultyRatingDialog = new DifficultyRating();

addTouchEvent(difficultyFeedbackDialogTooEasyBtnEl, () => {
  difficultyFeedbackDialogTooEasyBtnEl.children[1].textContent =
    "radio_button_checked";
  difficultyFeedbackDialogJustRightBtnEl.children[1].textContent =
    "radio_button_unchecked";
  difficultyFeedbackDialogTooHardBtnEl.children[1].textContent =
    "radio_button_unchecked";
  enableSubmitBtn();
  difficultyRatingDialog.rating = -1;
});
addTouchEvent(difficultyFeedbackDialogJustRightBtnEl, () => {
  difficultyFeedbackDialogTooEasyBtnEl.children[1].textContent =
    "radio_button_unchecked";
  difficultyFeedbackDialogJustRightBtnEl.children[1].textContent =
    "radio_button_checked";
  difficultyFeedbackDialogTooHardBtnEl.children[1].textContent =
    "radio_button_unchecked";
  enableSubmitBtn();
  difficultyRatingDialog.rating = 0;
});
addTouchEvent(difficultyFeedbackDialogTooHardBtnEl, () => {
  difficultyFeedbackDialogTooEasyBtnEl.children[1].textContent =
    "radio_button_unchecked";
  difficultyFeedbackDialogJustRightBtnEl.children[1].textContent =
    "radio_button_unchecked";
  difficultyFeedbackDialogTooHardBtnEl.children[1].textContent =
    "radio_button_checked";
  enableSubmitBtn();
  difficultyRatingDialog.rating = 1;
});

function enableSubmitBtn() {
  if (difficultyFeedbackDialogSubmitBtnEl.classList.contains("muted-btn"))
    difficultyFeedbackDialogSubmitBtnEl.classList.remove("muted-btn");
  difficultyFeedbackDialogSubmitBtnEl.classList.add("success-btn");
}

addTouchEvent(difficultyFeedbackDialogSkipBtnEl, difficultyRatingDialog.close);
addTouchEvent(
  difficultyFeedbackDialogSubmitBtnEl,
  difficultyRatingDialog.submit
);
